/**
 * Command model
 */

import { EnhancedInputData, SetupEnhInputData } from './EnhancedInputData';

export class Command {
    cmdtype: string = "CT_UNINITIALIZED";
    CommandName: string = "";
    CommandText: string = "";
    CommandPart2: string = "";
    CommandPart3: string = "";
    CommandPart4: string = "";
    CustomChoices: string[] = [];
    EnhInputData: EnhancedInputData | null = null;
    AllowHtml: boolean = false;
}

export function SetupCommandData(GameData: any[]): Command {
    const CurCommand = new Command();
    CurCommand.cmdtype = GameData[1];
    CurCommand.CommandName = GameData[2];
    CurCommand.CommandText = GameData[3];
    CurCommand.CommandPart2 = GameData[4];
    CurCommand.CommandPart3 = GameData[5];
    CurCommand.CommandPart4 = GameData[6];
    for (let i = 0; i < GameData[7].length; i++) {
        CurCommand.CustomChoices.push(GameData[7][i]);
    }
    CurCommand.EnhInputData = SetupEnhInputData(GameData[8]);
    return CurCommand;
}
